import { baseState, baseMutations } from '@/store/mixins'
import httpClient from '@/http-client'

const BASE_URL = '/api/v2/monthly-semester-mappings'

export default {
  namespaced: true,
  state: {
    ...baseState
  },
  mutations: {
    ...baseMutations
  },
  actions: {
    async fetch(context, attrubutes = {}) {
      let params = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
          search: context.state.search
        },
        attrubutes
      )
      let response = await httpClient.get(`${BASE_URL}`, {
        params
      })
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    onSave(context, data) {
      return httpClient.post(`${BASE_URL}`, data)
    },
    onUpdate(context, data) {
      return httpClient.put(`${BASE_URL}/${data.id}`, data)
    },
    onDelete(context, id) {
      return httpClient.delete(`${BASE_URL}/${id}`)
    },
    formViewModel(context, params = {}) {
      return httpClient.get(`${BASE_URL}/form-view-models`, { params })
    }
  }
}
